
import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { customFetchBase } from '../../utils/API/fetchBaseQuery';
import { encryptQueryString, transformRequest } from "../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSucessResponse } from "../../utils/API/responseMiddleware";

const skillAPI = createApi({
    reducerPath: "skillAPI",
    baseQuery: customFetchBase,
    endpoints: (builder) => ({
        //** List API */
        getSkill: builder.mutation({
            query: (userQuery) => ({
                url: '/Skill/GetSkillList',
                method: 'POST',
                body: transformRequest(userQuery)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getAllSkill: builder.query({
            query: () => ({
                url: encryptQueryString('/Skill/GetAllSkill'),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        //** Add  API */ 
        add: builder.mutation({
            query: (Details) => ({
                url: '/Skill/AddSkill',
                method: 'POST',
                body: transformRequest(Details)
            }),
        }),
        //** GetById API */
        getById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/Skill/GetSkillById/?id=${Number(id)}`),
                method: 'GET',
            }),
            providesTags: ['Skill'],
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        //**  Update API */
        update: builder.mutation({
            query: (Details) => ({
                url: '/Skill/UpdateSkill/',
                method: 'POST',
                body: transformRequest(Details)
            }),
            invalidatesTags: ['Skill'],
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        //** Delete API */
        delete: builder.mutation({
            query: (id) => ({
                url: `/Skill/DeleteSkill/?id=${id}`,
                method: 'DELETE',
                body: transformRequest(id)
            }),
        }),
        getAllMainSkill: builder.query({
            query: () => ({
                url: encryptQueryString(`/Skill/GetAllMainSkill`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    })
})

export const {
    useGetSkillMutation, useAddMutation,
    useLazyGetByIdQuery, useUpdateMutation,
    useDeleteMutation, useLazyGetAllSkillQuery,
    useLazyGetAllMainSkillQuery
} = skillAPI

export default skillAPI;